import { useState, useEffect } from 'react';
import { getLayoutsForProject } from '../api/scan-api';
import { Layout } from '../types';

export const useLayouts = (projectId: string | null, scanType: string | null) => {
  const [layouts, setLayouts] = useState<Layout[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Don't load layouts for Progress scans or if required params are missing
    if (!projectId || !scanType || scanType === 'Progress') {
      setLayouts([]);
      return;
    }

    const loadLayouts = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await getLayoutsForProject(parseInt(projectId), scanType);
        setLayouts(data);
      } catch (err) {
        console.error('Error loading layouts:', err);
        setError('Failed to load layouts');
      } finally {
        setIsLoading(false);
      }
    };

    loadLayouts();
  }, [projectId, scanType]);

  return { layouts, isLoading, error };
};

